module.exports = __webpack_public_path__ + "img/CG52.30573f62.jpg";